import React from "react";
import styles from './MenuBurgerButton.module.scss'

const MenuBurgerButton = () => {
  const [close, setClose] = React.useState<boolean>(false)
  return (
    <div onClick={() => setClose(!close)} className={styles.root}>
      {[...new Array(3)].map((_, i) => (
        <span key={i + 1} className={`${styles.item} ${close ? `${styles.active}` : ''} `} />
      ))}
    </div>
  );
};

export default MenuBurgerButton;
